var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRcBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 27,
    viewBox: "0 0 47 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.28271,
    width: 44,
    height: 24,
    fill: "#E75300",
    stroke: "#E75300",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.83897C19.0901 5.9324 18.711 6.1397 18.409 6.44172C17.9871 6.86368 17.75 7.43598 17.75 8.03271V18.5327C17.75 19.1295 17.9871 19.7017 18.409 20.1237C18.831 20.5457 19.4033 20.7827 20 20.7827H27C27.5967 20.7827 28.169 20.5457 28.591 20.1237C29.0129 19.7017 29.25 19.1295 29.25 18.5327V10.4013V10.4012C29.2499 10.0366 29.105 9.68696 28.8472 9.42916C28.8472 9.42914 28.8471 9.42913 28.8471 9.42911L25.6036 6.18559C25.3458 5.92771 24.9961 5.78279 24.6315 5.78271H24.6314H20H19.5V5.83897ZM25.3125 9.34521V8.80232L26.2304 9.72021H25.6875C25.588 9.72021 25.4927 9.68071 25.4223 9.61038C25.352 9.54005 25.3125 9.44467 25.3125 9.34521Z",
    fill: "#F7F7F7",
    stroke: "#E75300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcBack);
export default __webpack_public_path__ + "static/media/rc-back.bdbdab2ab04687cbb7f7c52376bdf2da.svg";
export { ForwardRef as ReactComponent };